import React from 'react';
import { NotFound } from './container';

export const NotFoundScreen = ({ navigation }: { navigation: any }) => {
    return <NotFound />;
};